/* eslint-disable import/prefer-default-export */
import { StreamData } from 'types/streamData'
import { SourceType, Domain } from 'enums'
import MediaType from 'enums/MediaType'
import { RichMentionedUrl } from 'schemas/RichMentionedUrlSchema'
import { VideoOrImageRichMentionedUrl } from '../../types'

export const isTwitterPost = (data: StreamData): boolean =>
  data.sourceType === SourceType.TWITTER || data.domain === Domain.TWITTER

export const filterVideoOrImageMedia = (mentionedUrls?: RichMentionedUrl[]) =>
  mentionedUrls &&
  (mentionedUrls.filter(
    (mentionedUrl) =>
      mentionedUrl.mediaType === MediaType.IMAGE || mentionedUrl.mediaType === MediaType.VIDEO
  ) as VideoOrImageRichMentionedUrl[])
